import { InstrumentIdentifiersProps } from './types';
import { useConfiguration } from '../../../../../../store/configurationStore';

export const useInstrumentIdentifiers = (props: InstrumentIdentifiersProps) => {
  const { sectionId } = props;
  const { templates, getValidationForSection } = useConfiguration();

  // Get the current section config
  const template = templates.find(t => t.id === props.templateId);
  const instrumentConfig = template?.instrumentConfigs.find(
    ic => ic.instrumentType === props.instrumentType
  );
  const section = instrumentConfig?.sections.find(
    s => s.id === props.sectionId
  );

  // COMMENTED OUT: Holdings lookup functionality disabled
  // // Extract holdings lookup from section config (with fallback)
  // const holdingsLookup = section?.config.holdingsLookup || {
  //   enabled: false,
  //   symbolColumn: null
  // };
  //
  // // Handler to update holdings lookup
  // const handleHoldingsLookupChange = (config: { enabled: boolean; symbolColumn: string | null }) => {
  //   updateHoldingsLookup(
  //     templateId,
  //     instrumentType,
  //     sectionId,
  //     config
  //   );
  // };

  // Read validation from store
  const validationResult = getValidationForSection(sectionId);

  // Suppress unused variable warning - section is used for future expansion
  void section;

  return {
    validationResult,
  };
};
